import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-c6cc1e4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "about" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Nightbane"),
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/Nightbane-Bandphoto.jpg",
    alt: "Nightbane Bandfoto",
    title: "Nightbane"
  }),
  /*#__PURE__*/_createElementVNode("p", null, " Nightbane ist eine Metal-Band, die den Geist der 80er-Jahre mit modernem Sound vereint. Gegründet 2024 in Lübeck hat sich Nightbane mittlerweile zu einer vollständigen Band formiert. Mit kraftvollen Gitarrenriffs, zweistimmigen Melodien und einer Leidenschaft für den klassischen Metal erschaffen wir Musik, die die Energie und Magie des 80er-Jahre Metal zurückbringt. Unsere kommende EP ist der erste Schritt auf einer Reise, die Vergangenheit und Gegenwart miteinander verbindet und die Bühnen zum Beben bringen wird. "),
  /*#__PURE__*/_createElementVNode("h2", null, "Arise EP"),
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/EPCover.png",
    class: "cover",
    title: "Nightbane - Arise EP"
  }),
  /*#__PURE__*/_createElementVNode("p", null, "Im November 2025 habe wir unsere erste EP veröffentlicht. Die Arise EP beinhaltet unsere ersten 4 Tracks")
], -1))

import TextPageLayout from '@/components/text-page-layout.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'AboutView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TextPageLayout, null, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}
}

})